<app-detail-card
  [isLoading]="isLoading"
  [title]="getCardTitle()"
  [image]="'assets/img/field-service.png'"
  [canUploadImage]="false"
  [contentToShow]="mode == getModes().NEW ? DetailCardContent.EMPTY : DetailCardContent.TABS"
  [tabs]="fieldServiceType != FieldServiceType.WORK_CENTER ? [
    { name: getTypeLabel(getChildFieldServiceType(), true) | titlecase, content: childrenFieldServices },
    { name: 'Physical assets', content: assets },
    { name: 'Personnel', content: personnel }
  ] : [
    { name: 'Physical assets', content: assets },
    { name: 'Personnel', content: personnel }
  ]"
  [actions]="getActions()"
>

  <div *ngIf="!isLoading" class="form" sidebar-content>

    <!-- General information -->
    <div class="group-title">{{ 'General information' | translate }}</div>
    <div class="group">

      <div class="col">

        <!-- Name -->
        <mat-form-field>
          <mat-label>{{ 'Name' | translate }}</mat-label>
          <input matInput [(ngModel)]="fieldService.name" required>
        </mat-form-field>
        <br>

        <!-- Description -->
        <mat-form-field>
          <mat-label>{{ 'Description' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="fieldService.description" rows="12"></textarea>
        </mat-form-field>
        <br>

        <!-- Parent field service -->
        <!--<mat-form-field appearance="fill">
          <mat-label>Set parent field service</mat-label>
          <mat-select [(ngModel)]="fieldServiceId" [ngModelOptions]="{standalone: true}">
            <mat-option>
              <ngx-mat-select-search placeholderLabel="Search field service..." [(ngModel)]="fieldServiceFilter" (ngModelChange)="updateFilteredFieldServices()" [ngModelOptions]="{standalone: true}"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="!fieldServices || filteredFieldServices.length == 0">No field service found</mat-option>
            <mat-option *ngIf="filteredFieldServices.length > 0" [value]="null">No parent field service</mat-option>
            <mat-option *ngFor="let fieldService of filteredFieldServices" [value]="fieldService.id">
              {{fieldService.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>-->

      </div>

    </div>

    <!-- Field service location -->
    <div class="group-title">{{ 'Field service address' | translate }}</div>
    <div class="group">

      <!-- Location address -->
      <mat-form-field>
        <mat-label>{{ 'Primary address' | translate }}</mat-label>
        <input matInput [(ngModel)]="fieldService.location.address" [required]="!fieldService.location.isEmpty()">
      </mat-form-field>
      <br>

      <!-- Location address 2 -->
      <mat-form-field>
        <mat-label>{{ 'Secondary address' | translate }}</mat-label>
        <input matInput [(ngModel)]="fieldService.location.address2">
      </mat-form-field>
      <br>

      <div class="row">

        <!-- Location city -->
        <mat-form-field>
          <mat-label>{{ 'City' | translate }}</mat-label>
          <input matInput [(ngModel)]="fieldService.location.city" [required]="!fieldService.location.isEmpty()">
        </mat-form-field>

        <!-- Location zip -->
        <mat-form-field>
          <mat-label>{{ 'Zip' | translate }}</mat-label>
          <input matInput [(ngModel)]="fieldService.location.zip" [required]="!fieldService.location.isEmpty()">
        </mat-form-field>

      </div>

      <!-- Location province initials -->
      <mat-form-field>
        <mat-label>{{ 'Province initials' | translate }}</mat-label>
        <input matInput [(ngModel)]="fieldService.location.provinceInitials" maxLength="2" minlength="2" [required]="!fieldService.location.isEmpty()">
      </mat-form-field>
      <br>

      <!-- Location country -->
      <mat-form-field>
        <mat-label>{{ 'Country' | translate }}</mat-label>
        <input matInput [(ngModel)]="fieldService.location.country" [required]="!fieldService.location.isEmpty()">
      </mat-form-field>
      <br>

      <div class="row">

        <!-- Location latitude -->
        <mat-form-field>
          <mat-label>{{ 'Latitude' | translate }}</mat-label>
          <input matInput [(ngModel)]="fieldService.location.latitude" type="number" [required]="!fieldService.location.isEmpty()">
        </mat-form-field>

        <!-- Location longitude -->
        <mat-form-field>
          <mat-label>{{ 'Longitude' | translate }}</mat-label>
          <input matInput [(ngModel)]="fieldService.location.longitude" type="number" [required]="!fieldService.location.isEmpty()">
        </mat-form-field>

      </div>

      <!-- Location altitude -->
      <mat-form-field>
        <mat-label>{{ 'Altitude' | translate }}</mat-label>
        <input matInput [(ngModel)]="fieldService.location.altitude" type="number" class="hide-spin-buttons" [required]="!fieldService.location.isEmpty()">
        <span matSuffix>{{ 'meters' | translate }}</span>
      </mat-form-field>

    </div>

  </div>

  <!-- Sidebar actions -->
  <ng-container sidebar-actions>
    <button *ngIf="mode == getModes().NEW" mat-raised-button color="primary" (click)="save()" [disabled]="!fieldService.validate()">{{ ('Create ' + getTypeLabel()) | translate }}</button>
    <button *ngIf="mode == getModes().UPDATE" mat-raised-button color="primary" (click)="save()" [disabled]="!fieldService.validate()">{{ ('Save ' + getTypeLabel()) | translate }}</button>
    <button *ngIf="mode == getModes().UPDATE" mat-raised-button color="warn" (click)="delete()">{{ ('Remove ' + getTypeLabel()) | translate }}</button>
  </ng-container>

  <!-- Empty statement on new item -->
  <ng-container empty-statement>
    {{ 'Create a field service to start adding location and personnel bindings' | translate }}
  </ng-container>

  <!-- Personnel bindings -->
  <ng-template #childrenFieldServices>

    <!-- Header -->
    <div class="header">

      <!-- Search bar -->
      <app-search-bar *ngIf="!environment.production" [placeholder]="'Search ' + getTypeLabel(getChildFieldServiceType()) + '...'" (textSubmit)="filterChildrenFieldServices($event)"></app-search-bar>

      <div class="spacer"></div>

      <!-- Actions -->
      <div class="actions">
        <button mat-stroked-button color="primary" (click)="router.navigate(['create'], { relativeTo: this.route })">
          <mat-icon>add</mat-icon> {{ ('New ' + getTypeLabel(getChildFieldServiceType())) | translate }}
        </button>
      </div>

    </div>

    <!-- Maintenances table -->
    <app-table
      [columns]="getChildrenFieldServicesTableColumns()"
      [rows]="getChildrenFieldServicesTableData()"
      [paginator]="childrenFieldServicePaginator"
      (onItemClicked)="showChildFieldService($event)"
    ></app-table>

  </ng-template>

  <ng-template #assets>

    <!-- Header -->
    <div class="header">

      <!-- Search bar -->
      <app-search-bar *ngIf="!environment.production" placeholder="Search physical asset..." (textSubmit)="filterPhysicalAsset($event)"></app-search-bar>

      <div class="spacer"></div>

      <!-- Actions -->
      <div class="actions">
        <!-- No action -->
      </div>

    </div>

    <!-- Physical assets table -->
    <app-table
      #assetTable
      [columns]="getPhysicalAssetsTableColumns()"
      [rows]="getPhysicalAssetsTableData()"
      [paginator]="personnelPaginator"
      (onItemClicked)="showPhysicalAsset($event)"
    ></app-table>

  </ng-template>

  <!-- Personnel bindings -->
  <ng-template #personnel>

    <!-- Header -->
    <div class="header">

      <!-- Search bar -->
      <app-search-bar *ngIf="!environment.production" placeholder="Search personnel..." (textSubmit)="filterPersonnel($event)"></app-search-bar>

      <div class="spacer"></div>

      <!-- Actions -->
      <div class="actions">
        <!-- No action -->
      </div>

    </div>

    <!-- Maintenances table -->
    <app-table
      [columns]="getPersonnelTableColumns()"
      [rows]="getPersonnelTableData()"
      [paginator]="personnelPaginator"
      (onItemClicked)="showPersonnel($event)"
    ></app-table>

  </ng-template>

</app-detail-card>
